module.exports = __webpack_public_path__ + "img/1497055610.09c62f5a.jpg";